module.exports = "/fonts/Roboto-LightItalic.ttf?2eeb30ebc5bee9ac3d42297cebca9a40";